// extracted by mini-css-extract-plugin
module.exports = {"pintxo-skeleton":"Skeleton_pintxo-skeleton__XN0v6","pintxo-skeleton-shape":"Skeleton_pintxo-skeleton-shape__qo0FL","fill-animation":"Skeleton_fill-animation__8JRDy"};